export default __webpack_public_path__ + "static/media/guide-11.03446957.png";